<!-- Notification -->
<div *ngIf="notificationVisible" class="notification gap-x-2 bg-badge px-6 py-4 rounded-lg flex-center-center text-sm mb-4 md:mb-6" [@slideInDownOnEnter]>
    <div class="max-md:hidden text-sub-text">[{{ latestMessage.created_at | date:'HH:mm MMM dd, yyyy'}}]</div>
    <div class="font-normal flex-1 min-w-0 truncate" [nz-tooltip]="notificationTooltip">{{ latestMessage.title}}</div>
    <span nz-icon nzType="close" class="!text-sub-text text-lg ml-3 cursor-pointer hover:!text-black" (click)="closeNotification()"></span>
</div>

<ng-template #notificationTooltip>
    <div class="text-sm leading-[22px]">
        <div>{{ latestMessage.title}}</div>
        <div class="text-[#999]">[{{ latestMessage.created_at | date:'HH:mm MMM dd, yyyy'}}]</div>
    </div>
</ng-template>
